import {
    Anchor,
    Box,
    Grid,
    Group,
    Image,
    Paper,
    Text,
    Title
} from "@mantine/core";

import {AiOutlineLink} from "react-icons/ai";
import {OutboundApplication} from "../types.ts";
import {internalUrl} from "../../../lib/internalUrl.ts";

const ApplicationLogoAnchor = ({application, href}: { application: OutboundApplication, href: string }) => {
    return (
        <Anchor href={href} target="_blank">
            <Image src={application.logo} alt={application.name}/>
        </Anchor>
    )
}

const TitleAndDescription = ({application, href}: { application: OutboundApplication, href: string }) => {
    return (
        <>
            <Box style={{marginBottom: 'var(--mantine-spacing-lg)'}}>
                <Title order={3}
                       style={{color: 'var(--mantine-color-dark-7)'}}>
                    <Group>
                        <Text tt={'uppercase'}>{application.name}</Text>
                        <Anchor href={href} target="_blank">
                            <AiOutlineLink/>
                        </Anchor>
                    </Group>
                </Title>
            </Box>
            <Box>
                <Text>{application.description}</Text>
            </Box>
        </>
    )
}

// application tile component
export const ApplicationTile = ({application}: { application: OutboundApplication }) => {

    const href = internalUrl(application.url, {campaign: application.campaign});

    switch (application.position) {
        case 'left':
            return (
                <Paper shadow="xl" p="xl" withBorder>
                    <Grid style={{padding: 'var(--mantine-spacing-xl)'}}>
                        <Grid.Col span={4} style={{
                            textAlign: 'center',
                            marginTop: '1em'
                        }}>
                            <ApplicationLogoAnchor application={application} href={href}/>
                        </Grid.Col>

                        <Grid.Col span={8}>
                            <TitleAndDescription application={application} href={href}/>
                        </Grid.Col>

                    </Grid>
                </Paper>
            )
        case 'right':
            return (
                <Paper shadow="xl" p="xl" withBorder>
                    <Grid style={{padding: 'var(--mantine-spacing-xl)'}}>

                        <Grid.Col span={8}>
                            <TitleAndDescription application={application} href={href}/>
                        </Grid.Col>

                        <Grid.Col span={4} style={{
                            textAlign: 'center',
                            marginTop: '1em'
                        }}>
                            <ApplicationLogoAnchor application={application} href={href}/>
                        </Grid.Col>
                    </Grid>
                </Paper>
            )
    }

}


